import React, {Component} from 'react';
import {connect} from 'react-redux';
import CenterScroller from '../Helpers/CenterScroller';
import historyVars from "../../utils/historyVars";
import setShowPopup from "../../actions/setShowPopup";
import HTML from '../Helpers/HTML';
import { Link } from 'react-router-dom'
import history from '../../history';

class UniversalPopup extends Component {
  renderActions() {
    const buttons=[];
    if(this.props.data.actions && this.props.data.actions.length) {
      for(let i in this.props.data.actions) {
        const cur=this.props.data.actions[i];
        buttons.push(
          <span onClick={()=>{
            this.props.setShowPopup(null);
            if(cur.route_to) {
              history.push(cur.route_to);
            }
            if(cur.on_click) {
              cur.on_click();
            }
          }} className={` mleft15 ${cur.klass}`}><span>{cur.title}</span></span>
        )

      }

    }
    return (
      <div className="tar">
        {buttons}
      </div>
    )
  }
  render() {
    const data=this.props.data;
    return (
      <CenterScroller closeTrigger={()=>{ this.props.setShowPopup(null); }} center={true} maxWidth={450}>
        <div className="s-padd10 m-padd20 bg-w1">
          <h2>{data.title}</h2>
          <HTML>{data.body}</HTML>
          {this.renderActions()}
        </div>
      </CenterScroller>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps,{ setShowPopup })(UniversalPopup);
